import * as React from "react";
import { Color } from "@glossy/colors";
import Portrait from "@ui-kit/identity/portrait";

export type IProps = Pick<
  React.ComponentProps<typeof Portrait>,
  "picture" | "editable" | "onClick" | "size" | "borderColor" | "className"
>;

const RadarlyPortraitQuery = ({
  picture,
  borderColor = Color.NightRider,
  editable,
  onClick,
  size,
  className,
}: IProps) => (
  <Portrait
    picture={picture}
    type="focus_query"
    editable={editable}
    onClick={onClick}
    size={size}
    borderColor={borderColor}
    className={className}
  />
);

export default RadarlyPortraitQuery;
